import { useState, useCallback, useEffect } from "react";
import TestTypeContext from "./TestTypeContext";

const TestTypeProvider = ({ children }) => {
  const [testType, setTestType] = useState("paper");

  const setType = useCallback((type) => {
    window.localStorage.setItem("Test Type", type);
    setTestType(type);
  }, []);

  const changeToPaperType = useCallback(() => {
    setType("paper");
  }, [setType]);

  const changeToElectronicType = useCallback(() => {
    setType("electronic");
  }, [setType]);

  useEffect(() => {
    const localTestType = window.localStorage.getItem("Test Type");
    if (localTestType) {
      setTestType(localTestType);
    } else {
      setTestType("paper");
      window.localStorage.setItem("Test Type", "paper");
    }
  }, [testType]);

  return (
    <TestTypeContext.Provider
      value={{ testType, changeToPaperType, changeToElectronicType }}
    >
      {children}
    </TestTypeContext.Provider>
  );
};

export default TestTypeProvider;
